import { BaseAdapter } from './base.adapter';
import {
  activeRefineLabelFromApi,
  artifactFromApi,
  canRegenerateFromApi,
  responseHistoryFromApi,
  type ResponseHistory,
  type SentinelArtifact,
} from './sentinelWorkspace.artifact.adapter';
import { blueprintFromApi, currentBlueprintFromApi } from './sentinelWorkspace.blueprint.adapter';
import { similarTicketsFromApi } from './sentinelWorkspace.similarTicket.adapter';
import { workspaceFromApi, ticketFromApi, ticketsFromApi } from './sentinelWorkspace.conversation.adapter';
import {
  classifyTraceStepKind,
  inflightTraceFromApi,
  isInternalTraceStep,
  mergeTraceSteps,
  traceHistoryFromApi,
} from './sentinelWorkspace.trace.adapter';
import type {
  AgentOption,
  Blueprint,
  ProviderAgentDto,
  SentinelBlueprintDto,
  SentinelConversation,
  SentinelOutboundAttachment,
  SentinelOutboundAttachmentWireDto,
  SentinelTicket,
  SentinelTicketWireDto,
  SentinelWorkspaceDetailWireDto,
} from '@/modules/sentinel-workspace/types';

export {
  activeRefineLabelFromApi,
  artifactFromApi,
  canRegenerateFromApi,
  classifyTraceStepKind,
  inflightTraceFromApi,
  isInternalTraceStep,
  mergeTraceSteps,
  traceHistoryFromApi,
  responseHistoryFromApi,
  similarTicketsFromApi,
};
export type { SentinelArtifact };

export class SentinelWorkspaceAdapter extends BaseAdapter {
  static artifactFromApi(dto: SentinelWorkspaceDetailWireDto): SentinelArtifact {
    return artifactFromApi(dto);
  }

  static responseHistoryFromApi(dto: SentinelWorkspaceDetailWireDto): ResponseHistory {
    return responseHistoryFromApi(dto);
  }

  static ticketFromApi(dto: SentinelTicketWireDto): SentinelTicket {
    return ticketFromApi(dto);
  }

  static ticketsFromApi(dtos: SentinelTicketWireDto[]): SentinelTicket[] {
    return ticketsFromApi(dtos);
  }

  static conversationFromApi(dto: SentinelWorkspaceDetailWireDto): SentinelConversation {
    return workspaceFromApi(dto);
  }

  static workspaceFromApi(
    dto: SentinelWorkspaceDetailWireDto,
  ): { conversation: SentinelConversation; blueprint: Blueprint | null } {
    return {
      conversation: workspaceFromApi(dto),
      blueprint: currentBlueprintFromApi(dto),
    };
  }

  static blueprintFromApi(dto: SentinelBlueprintDto): Blueprint {
    return blueprintFromApi(dto);
  }

  static agentsFromApi(dtos: ProviderAgentDto[]): AgentOption[] {
    return dtos.map(({ id, name, email }) => ({ id, name, email }));
  }

  static outboundAttachmentFromApi(dto: SentinelOutboundAttachmentWireDto): SentinelOutboundAttachment {
    return {
      key: dto.key,
      fileName: dto.fileName,
      contentType: dto.contentType,
      fileSize: dto.fileSize,
    };
  }

  static outboundAttachmentToApi(attachment: SentinelOutboundAttachment): SentinelOutboundAttachmentWireDto {
    return {
      key: attachment.key,
      fileName: attachment.fileName,
      contentType: attachment.contentType,
      fileSize: attachment.fileSize,
    };
  }
}
